import api from './api';

export const getRestaurantInformation = async (id) => {
    return await api.get(`/api/store/information/${id}`);
}

export const getRestaurant = async (domain) => {
    return await api.get(`/api/store/${domain}`);
}
